export default "__VITE_PUBLIC_ASSET__b5fe247e__"